import React, { useState } from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { useMutation } from "react-query";
import { sendPasswordReset } from "../../../queries/session";
import { FORM_ERROR } from "final-form";

const ForgotPasswordPage = ({ toast }) => {
  const [successMessage, setSuccessMessage] = useState(null);

  const passwordReset = useMutation(async (formData) => {
    await sendPasswordReset(formData);
  });

  const onSubmit = async (values) => {
    return await passwordReset
      .mutateAsync(values)
      .then(() => {
        setSuccessMessage("Email has been send");
        toast.success("Email has been send");
      })
      .catch(() => {
        toast.error("Email is not valid");
        return { [FORM_ERROR]: "Email is not valid" };
      });
  };
  return (
    <div className="fs-wrap fs-form">
      <ForgotPasswordForm onSubmit={onSubmit} successMessage={successMessage} />
    </div>
  );
};

ForgotPasswordPage.propTypes = {};

export default ForgotPasswordPage;
